import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { graphql } from 'react-apollo';
import { Spin, Table } from 'antd';
import IconButton from 'material-ui/IconButton';
import NewCustomerIcon from '@material-ui/icons/PersonAdd';

import getAllCustomersQuery from '../../graphql/queries/getAllCustomersQuery.graphql';

const { Column } = Table;

class AllCustomers extends Component {
  state = {
  };

  render() {
    const { url } = this.props.match;
    const { loading, customers } = this.props.data;
    if (loading) {
      return (
        <Spin size="large" />
      );
    }
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <h2>Customers</h2>
          </div>
        </div>

        <div className="ec-content-box">
          <Table dataSource={customers} rowKey="id">
            <Column
              title="Name"
              dataIndex="name"
              key="name"
              render={(text, record) => (
                <Link to={`${this.props.match.url}/${record.id}/factsheet`}>
                  {text}
                </Link>
              )}
            />
            <Column
              title="Constitution"
              dataIndex="constitution"
              key="constitution"
            />
            <Column
              title="Sector"
              dataIndex="sector"
              key="sector"
            />
            <Column
              title="Stage"
              dataIndex="stage"
              key="stage"
            />
            <Column
              title="Status"
              dataIndex="status"
              key="status"
            />
          </Table>
        </div>
      </div>
    );
  }
}

AllCustomers.propTypes = {
  data: PropTypes.shape({
    customers: PropTypes.array,
    loading: PropTypes.bool.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default graphql(getAllCustomersQuery)(AllCustomers);



// WEBPACK FOOTER //
// ./src/pages/customer/AllCustomers.jsx